import { HttpClient } from '@angular/common/http';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { UserService } from '@ml/core/services/user.service';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./user.service";
import * as i3 from "@angular/fire/messaging";
var PushNotificationsService = /** @class */ (function () {
    function PushNotificationsService(http, userService, angularFireMessaging) {
        this.http = http;
        this.userService = userService;
        this.angularFireMessaging = angularFireMessaging;
    }
    PushNotificationsService.prototype.subscribeChangeToken$ = function () {
        var _this = this;
        return this.angularFireMessaging.tokenChanges.pipe(filter(function (value) { return value !== _this.userService.user.fcmToken; }), switchMap(function (token) { return _this.userService.setFCMToken(token); }), catchError(function (error) { return of(null); }));
    };
    /**
     * Request permission for the current user
     */
    PushNotificationsService.prototype.requestPermission$ = function () {
        var _this = this;
        return this.angularFireMessaging.requestToken.pipe(filter(function (value) { return value !== _this.userService.user.fcmToken; }), switchMap(function (token) { return _this.userService.setFCMToken(token); }), catchError(function (error) { return of(null); }));
    };
    PushNotificationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PushNotificationsService_Factory() { return new PushNotificationsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UserService), i0.ɵɵinject(i3.AngularFireMessaging)); }, token: PushNotificationsService, providedIn: "root" });
    return PushNotificationsService;
}());
export { PushNotificationsService };
